/**
 * Maskiert eine Google-Ads-Kundennummer fuer die Anzeige.
 *
 * Stand bis zum 09.09.2026 in `AdsChapterTeaser.tsx`. Der Teaser ist mit der
 * Entlastung des Feed-Checks (Paket 3) entfallen -- die Funktion nicht: sie
 * ist die einzige Stelle, die entscheidet, wie viel von einer fremden
 * Kundennummer sichtbar wird, und gehoert damit ohnehin nicht in eine
 * Darstellungs-Komponente.
 */
export function maskCustomerId(id: string): string {
  const digits = id.replace(/\D/g, '');
  // Ads-Kundennummern sind 10-stellig. Alles andere wird generisch maskiert:
  // die alte `< 6`-Schwelle verwarf bei 6- bis 9-stelligen Inputs Ziffern und
  // haengte Phantom-X an -- eine erfundene Kundennummer im UI.
  if (digits.length !== 10) return 'XXX-XXX-XXXX';
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-XXXX`;
}
